import {createFileRoute} from '@tanstack/react-router';

import {CategoryLibrary} from '@/features/Library/components/Category/CategoryLibrary';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_library/categories')({
  component: CategoryLibrary,
  beforeLoad: () => makeDocumentTitle('Categories'),
});
